import { AnyAction, Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction } from '../models/api-model';
import { ExternalLinks, LovProcActionType, LovProcState } from '../models/lov-proc-model';
import { apiAction } from './base-api';


export const InitialState: LovProcState = {
	personLov: null,
    orgLov: null,
	mlpsLov: null,
    externalLinks: null,	
};

export const lovProcReducer = (state = InitialState, action: AnyAction): LovProcState => {

	switch (action.type) {
		case LovProcActionType.SET_PERSON_PROC_LOV:
			return {
				...state,
				personLov: action.payload,
			};
		case LovProcActionType.SET_ORG_PROC_LOV:
			return {
				...state,
				orgLov: action.payload,
            };
		case LovProcActionType.SET_MLPS_PROC_LOV:
			return {
				...state,
				mlpsLov: action.payload,
            };
        case LovProcActionType.SET_EXTERNAL_LINKS:
            return {
                ...state,
                externalLinks: action.payload,
            };
		default: return state;
	}
};


export const setPersonLov = (response: any) => {
	return {
		type: LovProcActionType.SET_PERSON_PROC_LOV,
		payload: response.data,
	};
};

export const setOrgLov = (response: any) => {
	return {
		type: LovProcActionType.SET_ORG_PROC_LOV,
		payload: response.data,
	};
};

export const setMlpsLov = (response: any) => {
	return {
		type: LovProcActionType.SET_MLPS_PROC_LOV,
		payload: response.data,
	};
};

export const setExternalLinks = (links: ExternalLinks) => {
    return {
        type: LovProcActionType.SET_EXTERNAL_LINKS,
        payload: links,
    };
};

export const getPersonLov = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.personPrc}/lov`,
		onSuccess,
		onFailure,
	});
};


export const getOrgLov = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.organizationPrc}/lov`,
		onSuccess,
		onFailure,
	});
};

export const getMlpsLov = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/lov`,
		onSuccess,
		onFailure,
	});
};

